import React from 'react';
import Table from 'react-bootstrap/Table';

import Display from '../../util/Display';
import DisplayPhone from '../common/DisplayPhone';
import DisplayEmail from '../common/DisplayEmail';

import './ProjectPreview.css';

class ProjectDetails extends React.Component {

  constructor(props) {
    super(props);
    this.setProjectInfo(props);
    this.id = props.project.id;
  }

  UNSAFE_componentWillReceiveProps(props) {
    if(props.property && props.project.id !== this.id ) {
      this.setProjectInfo(props);
    }
  }

  setProjectInfo = props => {
    const field = 'responsible_person';
    this.owners = Display.FieldValue(props.project, field, props.model.fields);
    this.developer_name = props.project.developer_name;
    
    var phones = props.project.phone;
    this.phones = [];
    if(phones !== '' && phones !== '~~') {
      phones = phones.substring(1, phones.length -1);
      phones = phones.split('~');
      this.phones = phones.map( phone => <DisplayPhone key={`p_d_${phone}`} phone={phone} /> );
    }

    var emails = props.project.email;
    this.emails = [];
    if(emails !== '' && emails !== '~~') {
      emails = emails.substring(1, emails.length -1);
      emails = emails.split('~');
      this.emails = emails.map(email => <DisplayEmail key={`p_e_${email}`} email={email} />);
    }
  }

  render() {
    return (
      <div className="row">   
      <div className="col-md-4"></div>
        <div className="col-md-8 leadsec">
          <Table className="table-sm table-borderless">
            <tbody>
              {/* <tr>
                <th>{this.props.ProjectName}</th>
                <td>
                  <span className="buttons-social"><FaFacebook /></span>
                  <span className="buttons-social"><FaTwitter /></span> 
                  <span className="buttons-social"><FaLinkedin /></span>
                </td>
              </tr> */}
              <tr> <th>Developer</th> <td>{this.developer_name ? this.developer_name : '-'}</td> </tr>
              <tr> <th>Sales Person</th> <td>{this.owners ? this.owners : '-'}</td> </tr>
              <tr> <th>Phone</th> <td>{this.phones ? this.phones : '-'}</td> </tr>
              <tr> <th>Email</th> <td>{this.emails ? this.emails : '-'}</td> </tr>
            </tbody>
          </Table>
        </div>   
      </div>
    );
  }
}

export default ProjectDetails;